export enum TooltipVisibleType {
  all,
  edit,
  grid,
  none,
}
